import React, { useState, useEffect } from "react";
import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import { Card, Box } from "@mui/material";
import { BaseOptionChart } from "../../charts";
import { connect } from "react-redux";

function CustomBarChart(props) {

  const [data, setData] = useState([0,0,0,0,0]);
  useEffect(() => {
    if (props.patients_visits && props.patients_visits.categories) {
      let temp = props.patients_visits.categories.map(cat => cat.count)
      setData(temp);
    }else {
      setData([0,0,0,0,0])
    }
  }, [props.patients_visits]);

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 6,
        borderRadiusApplication: "end",
      },
    },
    stroke: { show: true, width: 1, colors: ["#003366"] },
    xaxis: {
        categories: [
          "None",
          "Once",
          "2-3 times",
          "Monthly",                    
          ["Multiple", "times per", "month"],
        ],
        labels: {
            rotate: 0,
          style: { fontSize: "14px", colors: "#003366", whiteSpace: "normal" },
          offsetY: 5, // Adjust label position
        },
      },
    yaxis: {
      labels: {
        style: { fontSize: "12px", colors: "#666" },
        formatter: (val) => Math.round(val),
      },
    },
    tooltip: { enabled: false },
    grid: { show: false },
    dataLabels: { enabled: false },
  });

  const chartData = [
    {
      name: "Patients",
      data: data || [],
      color: ({ value }) => {
        if (value < 5000) return "rgba(62, 131, 151, 0.3)";
        if (value < 10000) return "rgba(62, 131, 151, 0.5)";
        if (value < 15000) return "rgba(62, 131, 151, 0.7)";
        return "rgba(62, 131, 151, 1)";
      },
    },
  ];

  return (
     <Card sx={{ boxShadow: "none", mt: 4, p: 2, width: "100%" }}>
          <Box sx={{ width: "100%" }}>
          <ReactApexChart options={chartOptions} series={chartData} type="bar" height={400} />
          </Box>
        </Card>
  );
}

const mapState = state => ({
  patients_visits: state.overview.patients_visits
});

const mapDispatch = ({
  overview: { getPromise_6 }
}) => ({
  getPromise_6: () => getPromise_6()
});

export default connect(mapState, mapDispatch)(CustomBarChart);
